import { jsx as _jsx } from "react/jsx-runtime";
import { ModuleFE_Utils } from '../../modules/ModuleFE_Utils/ModuleFE_Utils.js';
import { ComponentSync } from '../../core/ComponentSync.js';
export class Component_GenericRenderer extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state.currentRenderer = ModuleFE_Utils.getRenderer(nextProps.rendererKey, nextProps.props);
        state.props = nextProps.props;
        return state;
    }
    render() {
        const Renderer = this.state.currentRenderer;
        return _jsx(Renderer, { ...this.state.props });
    }
}
//# sourceMappingURL=Component_GenericRenderer.js.map